query PaymentAvailableAccountingEntries(
  $first: Int
  $after: Cursor
  $payCycleId: UUID!
  $filter: InvoiceFilter
  $orderBy: [InvoicesOrderBy!]
) {
  paymentAvailableAccountingEntries(
    first: $first
    after: $after
    payCycleId: $payCycleId
    filter: $filter
    orderBy: $orderBy
  ) {
    nodes {
      id
      transactionType {
        id
        transactionType
        isDocumentSigningPayment
      }
      vendorReference
      invoiceNumber
      description
      invoiceDate
      controlTotalAmount
    }
    aggregates {
      sum {
        controlTotalAmount
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
